export default {
  "Your email address": `Your email address`,
  "Fill This Field": `Fill This Field`,
  "FillThisField": `Fill This Field`,
  "Log In": `.Log In`,
  "Send": `Send`,
  "Button": {
    "Continue": `Continue`,
  },
  "login": {
    "WELCOME BACK": `WELCOME BACK`,
    "New to Swipe": `New to Swipe`,
    "Sign up": `Sign up`,
    "Your password": `Your password`,
    "Forgot your password": `Forgot your password`,
    "Log In": `Log In`,
  },
  "forgot-password": {
    "forgot-password": `forgot password`,
    "descriptions": `Please enter your registered e-mail address to receive instructions on how to restore your password`,
    "descriptions1": `An email has been sent to your email address to reset your password`,
    "Your email address": `Your email address`,
    "Send": `Send`,
    "Recovery Password": `Recovery Password`,
    "Create a new": `Create a new strong password that you don't use for any other websites`,
    "The password must": `The password must contain one capital letter, one number and a password length of at least 8 characters!`,
  },
  "signup": {
    "CREATE ACCOUNT": `CREATE ACCOUNT`,
    "Already have an account": `Already have an account`,
    "Business": `Business`,
    "Personal": `Personal`,
    "Company name": `Company name`,
    "CountryOfIssuance": `Country of issuance`,
    "SignUpCheckBox": `By registering, you accept our Terms of use and Privacy Policy`,
    "Phone": `Phone`,
    "SMS code": `SMS code`,
    "Country of issuance": `Country of issuance`,
  },
};
